module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (146).1c373d47.jpg";